import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { ExternalAppApi, ExternalAppDto } from '../../../api-client';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { getApiConfiguration } from '../../../common';

const QUERY_KEY = 'external-apps';

type UseGetExternalApps = (
  options?: Omit<
    UseQueryOptions<ExternalAppDto[], ErrorResponse, ExternalAppDto[], string[]>,
    'queryKey' | 'queryFn'
  >,
) => UseQueryResult<ExternalAppDto[]>;

export const useGetExternalApps: UseGetExternalApps = (options) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  const externalAppsApi = new ExternalAppApi(getApiConfiguration());
  return useQuery(
    [QUERY_KEY],
    async () => externalAppsApi.getExternalApps(tenantId).then((res) => res.data),
    options,
  );
};
